const theme = {
  colors: {
    main: '#090909',
    mainDark: '#000000',
    mainLight: '#1b1b1b',
    mainLighter: '#f6f3ee',
    accent: '#c0a375',
    accentDark: '#96764b',
    accentSoft: '#eee5d7',
    textColor: '#111111',
    mutedText: '#696969',
    surface: '#ffffff',
    surfaceMuted: '#f7f6f3',
    whiteColor: '#ffffff',
    errorRed: '#c43a3a',
    successGreen: '#237a50',
    shadow: 'rgba(0, 0, 0, 0.12)',
  },
  mediaQueries: {
    smallest: 'only screen and (max-width: 25em)',
    small: 'only screen and (max-width: 37.5em)',
    medium: 'only screen and (max-width: 56em)',
    ipad: 'only screen and (max-width: 48.125em)',
    large: 'only screen and (max-width: 80em)',
    largest: 'only screen and (max-width: 90em)',
    plus: 'only screen and (max-width: 25.8em)',
  },
};

export default theme;
